import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { useTenantData } from "contexts/tenant";

export const useOlderRows = (label: string) => {
  const { local_timezone: timezone } = useTenantData();
  const [today] = useState(() => dayjs().tz(timezone).startOf("day"));
  const cutoff = today.subtract(30, "day").startOf("day");
  const [showOlder, setShowOlder] = useState(false);
  const revealOlder = (timestamp: Dayjs | null) => {
    if (timestamp?.isBefore(cutoff)) setShowOlder(true);
  };
  const toggle = (
    <FormControlLabel
      control={
        <Checkbox
          checked={showOlder}
          onChange={(_, checked) => {
            setShowOlder(checked);
          }}
        />
      }
      label={label}
    />
  );
  return { today, cutoff, showOlder, revealOlder, toggle };
};
